import React from "react";
import { termsSections, termsUpdatedDate } from "../data/legalContent";

const Terms = () => {
  return (
    <div className="py-16 bg-white">
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <h1 className="font-heading font-extrabold text-4xl text-p3-navy mb-8">Terms and Conditions</h1>
        <div className="space-y-7">
          {termsSections.map((s, i) => (
            <div key={i}>
              {s.heading && <h2 className="font-heading font-bold text-xl text-p3-navy mb-2">{s.heading}</h2>}
              <p className="text-sm text-p3-muted leading-relaxed">{s.body}</p>
            </div>
          ))}
          <p className="text-sm text-p3-muted italic pt-4 border-t border-gray-100">
            This document was last updated on {termsUpdatedDate}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
